<template>
  <div class="p-3">
    <div class="row mb-4">
      <div class="col-md-12 mb-3">
        <em class="fas fa-info-circle text-orange mr-2" />
        <span class="color-gray-7 font-weight-bold font-16">
          Detalles de Asistencia Registradas
        </span>
      </div>
    </div>

    <!-- desktop -->
    <div class="mx-3 d-block d-md-block d-sm-none">
      <div class="row border__bottom--orange py-3">
        <div class="col-md-3">
          <div class="color-gray-7 font-16 font-weight-bold pl-4 ml-2">
            Fecha de Visita
          </div>
        </div>
        <div class="col-md-3">
          <div class="color-gray-7 font-16 font-weight-bold">
            Horario (Desde - Hasta)
          </div>
        </div>
        <div class="col-md-3">
          <div class="color-gray-7 font-16 font-weight-bold">
            Lugar de Servicio
          </div>
        </div>
        <div class="col-md-3">
          <div class="color-gray-7 font-16 font-weight-bold">
            Dirección Lugar de Servicio
          </div>
        </div>
      </div>
      <div
        v-for="(item, index) in rows"
        :key="`visit-item-${index}`"
        class="row border-bottom"
      >
        <div
          class="col-md-3 py-4 d-flex justify-content-start align-items-center pl-5"
        >
          <div class="color-black font-16">{{ item.visitDate | date }}</div>
        </div>
        <div class="col-md-3 py-4">
          <div class="color-black font-16 font-weight-normal ">
            {{ item.timeRange }}
          </div>
          <div class="color-gray-6 font-14 font-weight-normal">
            {{ item.duration }}
          </div>
        </div>
        <div class="col-md-3 py-4">
          <div class="color-black font-16 font-weight-normal ">
            {{ item.locationName | capitalize }}
          </div>
          <div class="color-gray-6 font-14 font-weight-normal">
            {{ item.companyName | capitalize }}
          </div>
        </div>
        <div class="col-md-3 py-4">
          <div class="color-black font-16 font-weight-normal ">
            {{ item.locationAddressLine1 | capitalize }}
          </div>
          <div class="color-gray-6 font-14 font-weight-normal">
            {{ item.locationMunicipalityName | capitalize }}
            {{ item.locationZipCode }}
          </div>
        </div>
      </div>
    </div>

    <!-- mobile   -->
    <div class="d-block d-md-none d-sm-block">
      <div
        v-for="(item, index) in rows"
        :key="`visit-item-${index}`"
        class="mb-4"
      >
        <div class="border-color--secondary-9 border-box rounded">
          <div class="row border__bottom--secondary-9 border-box mx-0 py-3">
            <div class="col-5">
              <div class="color-gray-7 font-10 font-weight-bold">
                Fecha de Visita
              </div>
            </div>
            <div class="col font-12">
              {{ item.visitDate | date }}
            </div>
          </div>
          <div class="row border__bottom--secondary-9 border-box mx-0 py-3">
            <div class="col-5">
              <div class="color-gray-7 font-10 font-weight-bold">
                Horario (Desde- Hasta)
              </div>
            </div>
            <div class="col">
              <div class="color-black font-12 font-weight-normal ">
                {{ item.timeRange }}
              </div>
              <div class="color-gray-6 font-11 font-weight-normal">
                {{ item.duration }}
              </div>
            </div>
          </div>
          <div class="row border__bottom--secondary-9 border-box mx-0 py-3">
            <div class="col-5">
              <div class="color-gray-7 font-10 font-weight-bold">
                Lugar de Servicio
              </div>
            </div>
            <div class="col">
              <div class="color-black font-12 font-weight-normal ">
                {{ item.locationName | capitalize }}
              </div>
              <div class="color-gray-6 font-11 font-weight-normal">
                {{ item.companyName | capitalize }}
              </div>
            </div>
          </div>
          <div class="row border-box mx-0 py-3">
            <div class="col-5">
              <div class="color-gray-7 font-12 font-weight-bold">
                Dirección Lugar de Servicio
              </div>
            </div>
            <div class="col font-12">
              {{ item.locationMunicipalityName | capitalize }}
              {{ item.locationZipCode }}
            </div>
          </div>
        </div>
        <div class="border-bottom mt-4" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssistanceVisit',
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.border-box {
  border-width: 7px !important;
}
</style>
